import React from "react"

function levelClass(tagId) {
  if (tagId >= 1 && tagId <= 5) {
    return `level${tagId}`
  }
  return 'level5'
}

class Tag extends React.Component {
  render() {
    const level = levelClass(this.props.tag.id)
    const isFilter = this.props.onClick !== undefined

    if (isFilter) {
      const selected = this.props.selected
      return (
        <button
          type="button"
          className={`activityFilterTag activityFilterTag--${level}${selected ? ' activityFilterTag--selected' : ''}`}
          onClick={() => this.props.onClick(this.props.tag.id)}
        >
          {this.props.tag.name}
        </button>
      )
    }

    return (
      <span className={`activityTag activityTag--${level}`}>
        {this.props.tag.name}
      </span>
    )
  }
}

export default Tag;
